import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

const roleService = {
  // Admin Dataroom Roles APIs
  dataroom: {
    // List dataroom roles
    list: async (dataroomUuid) => {
      try {
        const response = await api.get(`/datarooms/${dataroomUuid}/roles`);
        return normalizeApiResponse(response, 'roles');
      } catch (error) {
        throw error;
      }
    },

    // Get single dataroom role
    get: async (dataroomUuid, roleId) => {
      try {
        const response = await api.get(`/datarooms/${dataroomUuid}/roles/${roleId}`);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Create dataroom role
    create: async (dataroomUuid, data) => {
      try {
        const response = await api.post(`/datarooms/${dataroomUuid}/roles`, data);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Update dataroom role
    update: async (dataroomUuid, roleId, data) => {
      try {
        const response = await api.put(`/datarooms/${dataroomUuid}/roles/${roleId}`, data);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Delete dataroom role
    delete: async (dataroomUuid, roleId) => {
      try {
        const response = await api.delete(`/datarooms/${dataroomUuid}/roles/${roleId}`);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    }
  },

  // Super Admin Dataroom Roles APIs
  admin: {
    // List all dataroom roles - removed /api prefix as it's already in base URL
    list: async (params = {}) => {
      try {
        const response = await api.get('/admin/dataroom-roles', { params });
        return normalizeApiResponse(response, 'roles');
      } catch (error) {
        throw error;
      }
    },

    // Get single dataroom role
    get: async (roleId) => {
      try {
        const response = await api.get(`/admin/dataroom-roles/${roleId}`);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Create dataroom role
    create: async (data) => {
      try {
        const response = await api.post('/admin/dataroom-roles', data);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Update dataroom role
    update: async (roleId, data) => {
      try {
        const response = await api.put(`/admin/dataroom-roles/${roleId}`, data);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Delete dataroom role
    delete: async (roleId) => {
      try {
        const response = await api.delete(`/admin/dataroom-roles/${roleId}`);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    }
  },

  // Super Admin Dataroom-specific Roles APIs (for managing roles within a specific dataroom)
  superAdminDataroom: {
    // List roles for a specific dataroom
    list: async (dataroomUuid, params = {}) => {
      try {
        const response = await api.get(`/admin/datarooms/${dataroomUuid}/roles`, { params });
        
        // Handle the response structure
        if (response.data && response.data.roles) {
          return response.data;
        }
        
        return normalizeApiResponse(response, 'roles');
      } catch (error) {
        throw error;
      }
    },

    // Get single role from a specific dataroom
    get: async (dataroomUuid, roleId) => {
      try {
        const response = await api.get(`/admin/datarooms/${dataroomUuid}/roles/${roleId}`);
        
        // Handle various response structures
        if (response.data && response.data.role) {
          return { data: response.data.role };
        } else if (response.data && response.data.data) {
          return { data: response.data.data };
        } else if (response.data) {
          return { data: response.data };
        }
        
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Create role for a specific dataroom
    create: async (dataroomUuid, data) => {
      try {
        const response = await api.post(`/admin/datarooms/${dataroomUuid}/roles`, data);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Update role for a specific dataroom
    update: async (dataroomUuid, roleId, data) => {
      try {
        const response = await api.put(`/admin/datarooms/${dataroomUuid}/roles/${roleId}`, data);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    },

    // Delete role from a specific dataroom
    delete: async (dataroomUuid, roleId) => {
      try {
        const response = await api.delete(`/admin/datarooms/${dataroomUuid}/roles/${roleId}`);
        return normalizeApiResponse(response);
      } catch (error) {
        throw error;
      }
    }
  }
};

export default roleService;